﻿module Illy.SafeStack.Client.DropdownButton
    // This is CarePath specific as it uses components in jQueryUI

    open Elmish
    open Fable.React
    open Fable.React.Props
    open Illy.SafeStack.Client
    open Illy.SafeStack.Client.ActionButton

    type 'a ClickSideEffect =
        | ButtonClicked of 'a

    type 'a Msg =
        | ActionButtonMsg of 'a ActionButton.Msg
        | ToggleDropdown
        
    type 'a Model =
        {
            Open: bool
            Buttons: 'a ActionButton list
        }

    let init buttons =
        {
            Open = false
            Buttons = buttons
        }

    let updateButtons buttons model =
        { model with Buttons = buttons }

    let update msg model =
        match msg with
        | ActionButtonMsg (ActionButton.Msg.ButtonClicked id) ->
            { model with Open = false }, SideEffect.Event (ButtonClicked id)
        | ToggleDropdown ->
            { model with Open = not model.Open }, SideEffect.none

    let view model dispatch =
        div [ Class "dropdown" ]
            [
            if model.Buttons.Length > 0 then
                yield a
                    [
                        Class <| sprintf "dropdown-button %s" (if model.Open then "open" else "")
                        OnClick <| fun _ -> dispatch ToggleDropdown
                    ]
                    [
                        FontAwesome.regular "plus" [] []
                        str "Add..."
                    ]

                if model.Open then
                    yield div [ Class "dropdown-items" ]
                        [
                            for button in model.Buttons do
                                yield ActionButton.view button (ActionButtonMsg >> dispatch)
                        ]
            ]
